import { Navigate, useParams } from "react-router";
import { useWs } from "../../lib/nav";
import { useTicket, viewForTicket } from "../../lib/inbox";
import { Placeholder } from "../Placeholder";

/** The canonical ticket link (/<workspace>/tickets/<number>, DECISIONS 2026-09-24) opens the ticket in the view it lives in. */
export function TicketRedirect() {
  const { number = "" } = useParams(); const { ws, slug } = useWs();
  const n = /^\d+$/.test(number) ? Number(number) : null;
  const { data, error } = useTicket(slug, n);
  if (error || n === null) return <Placeholder title="No such ticket" milestone="nothing" what="This number belongs to no ticket you can see." />;
  if (!data) return null;
  return <Navigate to={ws(`/inbox/${viewForTicket(data)}/${data.number}`)} replace />;
}
